import RepairingService from "../../icons/RepairingService";
import { toast } from "react-hot-toast";
import { ADD_PRODUCT_FEES, DEL_PRODUCT_FEES } from "@/services/cart";
import { useState } from "react";
import CurrencyIcon from "@/components/icons/CurrencyIcon";

const ProductFees = ({ availableProductFees, item, locale }) => {
  const [isFeesApplied, setIsFeesApplied] = useState([]);
  const [active, setActive] = useState(false);

  const handleAddProdFees = async (data) => {
    const { error } = await ADD_PRODUCT_FEES(data);
    if (!error) {
      setIsFeesApplied((prev) => [...prev, data?.id]);
      toast.success(
        locale === "ar"
          ? "تم إضافة الخدمة بنجاح"
          : "The service has been added successfully"
      );
    }
  };

  const handleDelProdFees = async (data) => {
    const { error } = await DEL_PRODUCT_FEES(data);
    if (!error) {
      setIsFeesApplied((prev) => prev?.filter((item) => item != data?.id));
      toast.success(
        locale === "ar"
          ? "تم حذف الخدمة بنجاح"
          : "The service has been removed successfully"
      );
    }
  };
  return availableProductFees?.map((fee, i) => (
    <div key={i} className="grid grid-cols-1 gap-3">
      {Object.values(fee?.options || {}).map((option, idx) => (
        <div
          key={idx}
          className={`flex gap-3 mt-3 rounded-lg ${
            isFeesApplied?.includes(option?.fee_id) && "bg-gray-300"
          }`}
          onClick={() => {
            active === idx
              ? handleDelProdFees({
                  id: option.fee_id,
                  itemId: item?.item_id,
                })
              : handleAddProdFees({
                  id: option.fee_id,
                  options: option?.fee_option_id,
                  itemId: item?.item_id,
                });
            setActive(active === idx ? false : idx);
          }}
        >
          <div className="border w-24 h-24 p-5 rounded-lg">
            <RepairingService />
          </div>
          <div className="cursor-pointer px-1.5 rounded-md relative flex flex-col justify-between">
            <h3 className="mb-1 text-[16px] font-semibold">
              {locale === "ar" ? option?.title_ar : option?.title}
            </h3>
            <h5 className="text-[16px] font-bold flex items-center gap-1">
              {parseInt(option.price || 0).toFixed(1)}{" "}
              <CurrencyIcon className="w-4 h-4" />
            </h5>
          </div>
        </div>
      ))}
    </div>
  ));
};

export default ProductFees;
